// extracted by mini-css-extract-plugin
module.exports = {"container":"container--NoGroups-_components-Groups-routes__1hBIe"};